import {Swiper, Autoplay, EffectFade, Navigation, Pagination, Thumbs} from 'swiper'
import {loadBlockLazyImages} from "../helpers/lazy-load";

let heroSliderBlocks = $('.js-hero-slider-block')

if (heroSliderBlocks.length){
    heroSliderBlocks.each(function (){
        let block = $(this)

        let heroSwiper = new Swiper(block.find('.js-hero-slider')[0], {
            modules: [Autoplay, EffectFade, Navigation, Pagination],
            //effect: "fade",
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                slideChange: function () {
                    // stop prev slide video and play current left slider video
                    $(this.el).find('video').each(function(i, el) {
                        el.pause()
                        el.currentTime = 0
                    })
                    let curSLide = $(this.slides[this.activeIndex])
                    let video = curSLide.find('video')
                    if (video.length){
                        video[0].play()
                    }
                },

            },
        })


        let prevButton = block.find('.swiper-button-prev')
        let nextButton = block.find('.swiper-button-next')

        if ($(window).width() < 768) {
            console.log('init')

            let stepsSwiper = new Swiper(block.find('.js-hero-steps-slider')[0], {
                modules: [Autoplay, EffectFade, Navigation, Pagination],
                //loop: true,
                slidesPerView: 'auto',
                //freeMode: true,
                navigation: {
                    nextEl: nextButton[0],
                    prevEl: prevButton[0],
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
            })

        }


    })
}
